// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL Reports API (nestjs)
 * API for reports in WL
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { SpellingByStudentDateResponseDto } from './SpellingByStudentDateResponseDto'
import {
  SpellingByStudentDateResponseDtoFromJSON,
  SpellingByStudentDateResponseDtoFromJSONTyped,
  SpellingByStudentDateResponseDtoToJSON,
} from './SpellingByStudentDateResponseDto'

/**
 *
 * @export
 * @interface SchoolsControllerGetSpellingByStudentDate200Response
 */
export interface SchoolsControllerGetSpellingByStudentDate200Response {
  /**
   *
   * @type {Array<SpellingByStudentDateResponseDto>}
   * @memberof SchoolsControllerGetSpellingByStudentDate200Response
   */
  data: Array<SpellingByStudentDateResponseDto>
  /**
   *
   * @type {number}
   * @memberof SchoolsControllerGetSpellingByStudentDate200Response
   */
  total: number
  /**
   *
   * @type {number}
   * @memberof SchoolsControllerGetSpellingByStudentDate200Response
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof SchoolsControllerGetSpellingByStudentDate200Response
   */
  itemsPerPage: number
  /**
   * Additional metadata
   * @type {object}
   * @memberof SchoolsControllerGetSpellingByStudentDate200Response
   */
  meta?: object
}

/**
 * Check if a given object implements the SchoolsControllerGetSpellingByStudentDate200Response interface.
 */
export function instanceOfSchoolsControllerGetSpellingByStudentDate200Response(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value
  isInstance = isInstance && 'total' in value
  isInstance = isInstance && 'page' in value
  isInstance = isInstance && 'itemsPerPage' in value

  return isInstance
}

export function SchoolsControllerGetSpellingByStudentDate200ResponseFromJSON(
  json: any,
): SchoolsControllerGetSpellingByStudentDate200Response {
  return SchoolsControllerGetSpellingByStudentDate200ResponseFromJSONTyped(
    json,
    false,
  )
}

export function SchoolsControllerGetSpellingByStudentDate200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SchoolsControllerGetSpellingByStudentDate200Response {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(
      SpellingByStudentDateResponseDtoFromJSON,
    ),
    total: json['total'],
    page: json['page'],
    itemsPerPage: json['itemsPerPage'],
    meta: !exists(json, 'meta') ? undefined : json['meta'],
  }
}

export function SchoolsControllerGetSpellingByStudentDate200ResponseToJSON(
  value?: SchoolsControllerGetSpellingByStudentDate200Response | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(
      SpellingByStudentDateResponseDtoToJSON,
    ),
    total: value.total,
    page: value.page,
    itemsPerPage: value.itemsPerPage,
    meta: value.meta,
  }
}
